import React, {useEffect, useRef, useState} from 'react';
import starter from './donate-rates/100-200.png';
import tier200 from './donate-rates/200.jpg';
import tier300 from './donate-rates/300.jpg';
import tier500 from './donate-rates/500.jpg';
import tier1000 from './donate-rates/1000.jpg';
import './DonateRates.css';

const rates=[
  {label:'50 / 100 บาท',src:starter,caption:'แพ็กเริ่มต้น',alt:'แพ็ก 50 บาท รับ 500 โกลด์และ 500 คูปอง แพ็ก 100 บาท รับ 1,100 โกลด์และ 1,100 คูปอง'},
  {label:'200 บาท',src:tier200,caption:'ของแถม 1 ชุด',alt:'อัตราโดเนท 200 บาท พร้อมรายละเอียดโกลด์ คูปอง และของแถม'},
  {label:'300 บาท',src:tier300,caption:'ของแถม 1 ชุด',alt:'อัตราโดเนท 300 บาท พร้อมรายละเอียดโกลด์ คูปอง และของแถม'},
  {label:'500 บาท',src:tier500,caption:'ของแถม 2 ชุด',alt:'อัตราโดเนท 500 บาท พร้อมรายละเอียดโกลด์ คูปอง และของแถม'},
  {label:'1,000 บาท',src:tier1000,caption:'ของแถม 4 ชุด + รางวัลพิเศษ',alt:'อัตราโดเนท 1,000 บาท พร้อมรายละเอียดโกลด์ คูปอง และของแถมพิเศษ'},
];
export function DonateRates(){
  const [selected,setSelected]=useState<number|null>(null);
  const close=useRef<HTMLButtonElement>(null),trigger=useRef<HTMLElement|null>(null);
  useEffect(()=>{
    if(selected===null)return;
    trigger.current=document.activeElement as HTMLElement;close.current?.focus();
    const key=(event:KeyboardEvent)=>{if(event.key==='Escape')setSelected(null);if(event.key==='Tab'){event.preventDefault();close.current?.focus();}};
    window.addEventListener('keydown',key);
    return()=>{window.removeEventListener('keydown',key);trigger.current?.focus();};
  },[selected]);
  return <section className="donate-rates" aria-labelledby="donate-rates-title">
    <header><div><span>DONATION REWARDS</span><h3 id="donate-rates-title">อัตราโดเนทและของแถม</h3></div><p>กดที่รูปเพื่อดูรายละเอียดเต็ม</p></header>
    <div className="donate-rates-grid">{rates.map((rate,index)=><button key={rate.label} onClick={()=>setSelected(index)} aria-label={`ดูรูปอัตราโดเนท ${rate.label}`}>
      <div className="donate-rate-art"><img src={rate.src} alt={rate.alt} loading="lazy" decoding="async"/><span aria-hidden="true">↗ ดูรูปเต็ม</span></div>
      <div className="donate-rate-caption"><strong>{rate.label}</strong><small>{rate.caption}</small></div>
    </button>)}</div>
    {selected!==null&&<div className="donate-lightbox" onClick={event=>{if(event.target===event.currentTarget)setSelected(null);}}>
      <section role="dialog" aria-modal="true" aria-label={`อัตราโดเนท ${rates[selected].label}`}>
        <header><strong>แพ็กโดเนท {rates[selected].label}</strong><button ref={close} onClick={()=>setSelected(null)} aria-label="ปิดรูปอัตราโดเนท">ปิด ✕</button></header>
        <div className="donate-lightbox-image"><img src={rates[selected].src} alt={rates[selected].alt}/></div>
      </section>
    </div>}
  </section>;
}
